import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  (muiTheme) => ({
    chip: {
      margin: muiTheme.spacing(0, 1, 1, 0),

      [muiTheme.breakpoints.up('md')]: {
        margin: muiTheme.spacing(0, 4, 3, 0),
      },

      '&.MuiButtonBase-root': {
        margin: muiTheme.spacing(0, 1, 1, 0),

        [muiTheme.breakpoints.up('md')]: {
          margin: muiTheme.spacing(0, 4, 3, 0),
        },
      },
    },
  }),
  { name: 'GenElasticChipFilters' },
);

export default useStyles;
